const getMultilineEllipsisSX = (lines) => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  "-webkit-line-clamp": `${lines}`,
  "-webkit-box-orient": "vertical"
});
export {
  getMultilineEllipsisSX
};
